import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class Appointment2Model {

	static STATUS_PLANNING = 'PLANNING';
	static STATUS_PLANNED = 'PLANNED';
	static STATUS_PENDING = 'PENDING';
	static STATUS_CLOSED = 'CLOSED';
	static STATUS_EXPIRED = 'EXPIRED';
	static STATUS_PLANNING_HIDDEN = 'PLANNING_HIDDEN';


	static APPOINTMENT_TYPE_DELIVERY = 'DELIVERY';
	static APPOINTMENT_TYPE_CLOSING = 'RETURN';
	static APPOINTMENT_TYPE_EXCHANGE_1 = 'EXCHANGE_1';
	static APPOINTMENT_TYPE_EXCHANGE_2 = 'EXCHANGE_2';
	static APPOINTMENT_TYPE_AUTHORITY = 'AUTHORITY';
	static APPOINTMENT_TYPE_USERCHANGE_RETURN = 'CU_RETURN';
	static APPOINTMENT_TYPE_USERCHANGE_DELIVERY = 'CU_DELIVERY';

	static APPOINTMENT_STATS_GRANULARITY = 'place';
	static APPOINTMENT_AT_HEADQUARTERS_0_15KM = 'KM_0_15';

	static TIME_SLOT_AM = 'AM';
	static TIME_SLOT_PM = 'PM';
	static TIME_SLOT_FULL_DAY = 'FULL_DAY';
	static DELIVERY_RETURN = 'DELIVERY_RETURN';
	static EXCHANGE_2_RETURN = 'EXCHANGE_2_RETURN';

	id: string;
	type: string;
	status: string;
	calendar_id: string;
	datetime_confirmed: string;
	datetime_proposal: string;
	datetime_rejected: string;
	at_headquarters_address: HeadquartersAddress;
	pick_up_office_address: HeadquartersAddress;
	at_headquarters: string;
	delivery_type: string;
	expires_at: string;
	contract: Contract;
	note: string;
	place: Place | any;
	guests: Guest[];
	contacts: Contact[];
	options: AppointmentOption[];
	created_at: string;
	updated_at: string;
	checked = false;
	metadata?: any;


	constructor(model?: any) {
		this.guests = [];
		this.options = [];
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.type = model.type;
			this.status = model.status;
			this.note = model.note;
			this.calendar_id = model.calendar_id;
			this.datetime_confirmed = model.datetime_confirmed;
			this.datetime_proposal = model.datetime_proposal;
			this.datetime_rejected = model.datetime_rejected;
			this.expires_at = model.expires_at;
			this.created_at = model.created_at;
			this.updated_at = model.updated_at;
			this.at_headquarters = model.at_headquarters;
			this.delivery_type = model.delivery_type;
			if (!Utilities.isVoid(model.contacts)) {
				if (model.contacts.length > 0){
					this.contacts = model.contacts
				}
				else{
					this.contacts = [];
				}
				
			}
			if (!Utilities.isVoid(model.contract)) {
				this.contract = new Contract(model.contract);
			}
			if (!Utilities.isVoid(model.place)) {
				this.place = new Place(model.place);
			}
			if (!Utilities.isVoid(model.guests)) {
				for (let i = 0; i < model.guests.length; i++) {
					this.guests.push(new Guest(model.guests[i]));
				}
			}
			if (!Utilities.isVoid(model.options)) {
				for (let i = 0; i < model.options.length; i++) {
					this.options.push(new AppointmentOption(model.options[i]));
				}
			}
			if (!Utilities.isVoid(model.checked)) {
				this.checked = model.checked;
			}
			if (!Utilities.isVoid(model.at_headquarters_address)) {
				this.at_headquarters_address = model.at_headquarters_address;
			}
			if (!Utilities.isVoid(model.pick_up_office_address)) {
				this.pick_up_office_address = model.pick_up_office_address;
			}

			this.metadata = model.metadata;
		}
	}
}

export enum DeliveryType {
	AT_THE_OFFICE = 'AT_THE_OFFICE',
	WITH_LOGISTIC = 'WITH_LOGISTIC',
	WITHOUT_LOGISTIC = 'WITHOUT_LOGISTIC',
	HOME_CLOSING = 'HOME_CLOSING',
}

export class Contract {
	ald_order_id: string;
	plate: string;
	company_name: string;
	notification_outcome: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.ald_order_id = model.ald_order_id;
			this.plate = model.plate;
			this.company_name = model.company_name;
			this.notification_outcome = model.notification_outcome;
		}
	}
}

export class HeadquartersAddress {
	street?: string;
	street_nr?: string;
	zip?: string;
	locality?: string;
	province?: string;
	region?: string;
	state?: string;
	city?: string;
	cod_iso_state?: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.street = model.street;
			this.street_nr = model.street_nr;
			this.zip = model.zip;
			this.locality = model.locality;
			this.province = model.province;
			this.region = model.region;
			this.state = model.state;
			this.city = model.city;
			this.cod_iso_state = model.cod_iso_state;
		}
	}

}

export class Contact {
	email: string;
	phone: string;
	name: string;
	prefixPhone: string;
	notes?: string;
	surveyor_id?: number;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.email = model.email;
			this.phone = model.phone;
			this.name = model.name;
		}
	}
}


export class Place {
    static TYPE_SERVICE_POINT = 'SERVICE_POINT';
    static TYPE_PERSONAL_ADDRESS = 'PERSONAL_ADDRESS';


	place_id?: string;
	name: string;
	type?: string;
	contact_phone?: string;
	ald_commodity_id: any;
	ald_supplier_code: any;
	address: string;
	address_number: string;
	lat?: string;
	lng?: string;
	distance?: number;
	has_dedicated_expert: boolean;
	zip_code: string;
	municipality: string;
	province?: string;
	region?: string;
	state?: string;
	center_id?:string;
	network_name? :string;
	ald_supplier_id?: number;
	flag_premium_point?:boolean;
	flag_service_box?:boolean;
	type_description?:string;
	flag_return_point?:boolean;
	flag_delivery_point?:boolean;
	flag_dedicated_expert?:boolean;
	flag_base_ald?:boolean;
	flag_mobstore?:boolean;
	flag_2w?:boolean;




	constructor(model?: any) {
	    if (!Utilities.isVoid(model)) {
		    this.place_id = model.place_id;
		    this.name = model.name;
		    this.type = model.type;
			this.type_description = model.type_description;

		    this.contact_phone = model.contact_phone;
		    this.ald_commodity_id = model.ald_commodity_id;
		    this.ald_supplier_code = model.ald_supplier_code;
		    this.address = model.address;
		    this.address_number = model.address_number;
		    this.zip_code = model.zip_code;
		    this.municipality = model.municipality;
		    this.lat = model.lat;
		    this.lng = model.lng;
		    this.has_dedicated_expert = model.has_dedicated_expert;
		    this.distance = model.distance;
		    this.province = model.province;
		    this.region = model.region;
			this.state = model.state;
			this.center_id =model.center_id;
			this.network_name =model.network_name;
			this.ald_supplier_id = model.ald_supplier_id;
			this.flag_premium_point=model.flag_premium_point;
			this.flag_service_box=model.flag_service_box;
			this.flag_return_point=model.flag_return_point;
			this.flag_delivery_point=model.flag_delivery_point;
			this.flag_dedicated_expert=model.flag_dedicated_expert;
			this.flag_base_ald=model.flag_base_ald;
			this.flag_mobstore=model.flag_mobstore;
			this.flag_2w=model.flag_2w;

		}
    }
}


export class Guest {
	static TYPE_MYALD_DRIVER: string = 'MYALD_DRIVER';
	static TYPE_MYALD_DELEGATE: string = 'MYALD_DELEGATE';
	static TYPE_MYALD_USER: string = 'MYALD_USER';
	static TYPE_NEMO_EXPERT: string = 'NEMO_EXPERT';
	static TYPE_NEMO_USER: string = 'NEMO_USER';


	email: string;
	surname: string;
	tax_code: string;
	license_code: string;
	mobile_prefix: string;
	name: string;
	mobile: string;
	type: string;
	user_id: string;
	calendar_id: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.name = model.name;
			this.mobile = model.mobile;
			this.type = model.type;
			this.user_id = model.user_id;
			this.calendar_id = model.calendar_id;
			this.email = model.email;
			this.surname = model.surname;
			this.tax_code = model.tax_code;
			this.license_code = model.license_code;
			this.mobile_prefix = model.mobile_prefix;
		}
	}
}

export class AppointmentOption {
	id: string;
	time_slot: number | string;
	favorite: boolean;
	date: any;
	expired: boolean;

	constructor(model?: any) {
		if (model) {
			if (!Utilities.isVoid(model.id)) {
				this.id = model.id;
			}
			this.time_slot = model.time_slot;
			this.favorite = model.favorite;
			this.date = model.date;
			if (!Utilities.isVoid(model.expired)) {
				this.expired = model.expired;
			}
			this.updateExpired();
		}
	}

	updateExpired(): void {
		const dateOption: Date = DateUtilities.getDate(this.date);
		dateOption.setHours(23, 59, 0);
		const dateNow: Date = DateUtilities.getNow();
		this.expired = DateUtilities.compareDateIsBefore(dateOption, dateNow);
	}
}

export class UpdateAppointment {
	id: string;
	contact_phone: string;
	datetime_proposal: string;
	datetime_rejected: string;
	note: string;
	guests: Guest[];
	datetime_confirmed: string;
	place: Place;
	contract: Contract;
	type: string;
	contacts: Contact[];
	at_headquarters_address: HeadquartersAddress;
	at_headquarters: string;
	metadata?: any;


	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.contact_phone = model.contact_phone;
			this.datetime_proposal = model.datetime_proposal;
			this.datetime_rejected = model.datetime_rejected;
			this.note = model.note;
			this.guests = model.guests;
			this.datetime_confirmed = model.datetime_confirmed;
			this.place = model.place;
			this.at_headquarters_address = model.at_headquarters_address;
			this.at_headquarters = model.at_headquarters;
			this.metadata = model.metadata;
		}
	}
}

export class AttachedAppointmentModel {
	blob_name: string;
	blob_type: string;
	created_at: string;
	description: string;
	file_name: string;
	file_size: string;
	id: string;
	mime_type: string;
	resource_id: string;
	resource_type: string;
	status: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.blob_name = model.blob_name;
			this.blob_type = model.blob_type;
			this.created_at = model.created_at;
			this.description = model.description;
			this.file_name = model.file_name;
			this.file_size = model.file_size;
			this.id = model.id;
			this.mime_type = model.mime_type;
			this.resource_id = model.resource_id;
			this.resource_type = model.resource_type;
			this.status = model.status;
		}
	}
}

export enum Appointment2ModelStatus {
	PLANNING = 'PLANNING',
	PLANNED = 'PLANNED',
	PENDING = 'PENDING',
	CLOSED = 'CLOSED',
	EXPIRED = 'EXPIRED',
	PLANNING_HIDDEN = 'PLANNING_HIDDEN',
}

export enum Appointment2ModelType {
	DELIVERY = 'DELIVERY',
	CLOSING = 'RETURN',
	EXCHANGE_1 = 'EXCHANGE_1',
	EXCHANGE_2 = 'EXCHANGE_2',
	AUTHORITY = 'AUTHORITY',
	USERCHANGE_RETURN = 'CU_RETURN',
	USERCHANGE_DELIVERY = 'CU_DELIVERY',
}
